export default [
  {
    path: '/playlists',
    name: 'playlists',
    component: () => import('@/pages/Playlists.vue'),
  },
  // {
  //   path: '/playlists/:id',
  //   name: 'bootcamp',
  //   component: () => import('@/pages/Playlist.vue'),
  // },
]
